import * as React from "react";
import Select from "react-select";
import { keys, head } from "lodash";

import { SelectFieldTypeProps } from "./types";
import { FormFieldTypes } from "../../types";
import styles from "../../styles";

import fieldNames from "../fieldNames";
import { AppContext } from "@/AppContext";
// import ComponentSelectorStor_ies from "../../../../Editor/components/ComponentSelector/ComponentSelector.stor_ies";

const allFieldNames = [
  ...fieldNames,
  {
    attributes: { name: false },
    label: "-----------------------",
  },
  {
    attributes: { name: "custom" },
    label: "Use a Custom Field Type",
  },
]

/**
 * Presents a way to select the type of form field.
 *
 * - Provides a number of common (prebuilt) choices (name/email/shipping)
 * - Lets the user create a customer one as well
 */
const SelectFieldType: React.FC<SelectFieldTypeProps> = ({
  type,
  preset,
  caption,
  onChange,
}) => {
  const [customFieldsAreShowing, setCustomFieldsAreShowing] = React.useState<
    boolean
  >(false);

  const { darkMode } = React.useContext(AppContext)

  return (
    <div
      data-testid="FormBuilder-EditFormField-SelectFieldType"
      style={{ zIndex: 100 }}
    >
      {caption && <span>{caption}</span>}
      <div className="border dark:border-white/10 rounded p-2 ">
        <Select
          // unstyled
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              backgroundColor: 'transparent',
              border: 'transparent',
            }),
            menu: (baseStyles) => ({
              ...baseStyles,
              backgroundColor: darkMode ? '#1a1a1a' : 'white',
            }),
            option: (baseStyles, state) => ({
              ...baseStyles,
              backgroundColor: state.isFocused
                ? (darkMode ? '#2a2a2a' : '#e6e6e6')
                : (darkMode ? '#1a1a1a' : 'white'),
              color: darkMode ? 'white' : 'black',
            }),
            singleValue: (baseStyles) => ({
              ...baseStyles,
              color: 'inherit',
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              color: 'inherit',
            }),
            dropdownIndicator: (baseStyles) => ({
              ...baseStyles,
              color: 'inherit',
            }),
          }}
          defaultValue={head(
            allFieldNames.filter((itm) => itm.attributes?.name === preset)
          )}
          options={allFieldNames.map((type) => ({
            ...type,
            value: type.attributes?.name,
          }))}
          onChange={(e) => {
            if (e?.value) {
              if (e.value !== "custom") {
                onChange(e.fieldType as FormFieldTypes, e.value, e.attributes);
              } else {
                setCustomFieldsAreShowing(true);
              }
            }
          }}
        />
      </div>

      {(customFieldsAreShowing || preset === "custom") && (
        <div style={styles.select.container}>
          <select
            style={styles.select.element}
            onChange={(e) =>
              onChange(e.target.value as FormFieldTypes, "custom")
            }
            value={type}
          >
            <option value={false}>Select Form Field ...</option>
            {keys(FormFieldTypes).map((itm, key) => (
              <option
                key={key}
                // selected={type === FormFieldTypes[itm]}
                value={FormFieldTypes[itm]}
              >
                {FormFieldTypes[itm]}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default SelectFieldType;
